import React, { Component } from 'react';

export default class ImageSelector extends Component {

    onSelectImage = () => {
        this.fileSelector.click();
    }

    render() {
        const { src, onChangeImage,onDeleteImage, showButton,key } = this.props;

        return(
            <div className="product-image-container">
                <input type="file" className="hidden" onChange={onChangeImage} ref={ref => this.fileSelector = ref } accept="image/x-png,image/jpeg"/>
                {src ? (
                    <>
                        <img src={typeof src === 'string' ? src : URL.createObjectURL(src)} alt="product" className="product-image"/>
                        <div className="image-overlay" >
                            <p onClick={this.onSelectImage}>Change Image</p> &ensp;
                            <p onClick={onDeleteImage}><i className="fa fa-trash" /></p>
                        </div>
                     
                    </>
                ) : showButton ? (
                    <div className="d-flex justify-content-center align-items-center border-1">
                        <button className="btn btn-primary btn-sm" onClick={this.onSelectImage}>Choose&nbsp;Image</button>
                    </div>
                ) : null }
            </div>
        )
    }
}